// All - class
import { EquipmentsAllTypes } from '@numeo/types-core'

export const allTypes = EquipmentsAllTypes.ALL_CLASS_TYPES
export const subTypes = EquipmentsAllTypes.EQUIPMENT_SUB_TYPES
